import { render, staticRenderFns } from "./DeliveryList.vue?vue&type=template&id=20ba81e8&scoped=true"
import script from "./DeliveryList.vue?vue&type=script&lang=js"
export * from "./DeliveryList.vue?vue&type=script&lang=js"
import style0 from "./DeliveryList.vue?vue&type=style&index=0&id=20ba81e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba81e8",
  null
  
)

export default component.exports